import {apiRequest} from "./apiRequest";
import type {
  SmsSenderPolicy,
  SmsSenderRegistration,
  SmsSenderRegistrationCreateRequest,
  SmsSenderRegistrationUpdateRequest,
} from "@calendall/shared";

export async function getSmsSenderPolicy(): Promise<SmsSenderPolicy> {
  return apiRequest<SmsSenderPolicy>({path: "admin/configuration/sms-sender-policy"});
}

export async function updateSmsSenderPolicy(policy: SmsSenderPolicy): Promise<SmsSenderPolicy> {
  return apiRequest<SmsSenderPolicy>({
    path: "admin/configuration/sms-sender-policy",
    method: "PUT",
    body: policy,
  });
}

export async function getSmsSenderRegistrations(tenantId: string): Promise<SmsSenderRegistration[]> {
  return apiRequest<SmsSenderRegistration[]>({path: `admin/tenants/${tenantId}/sms-sender-registrations`});
}

export async function createSmsSenderRegistration(
  tenantId: string,
  request: SmsSenderRegistrationCreateRequest,
): Promise<SmsSenderRegistration> {
  return apiRequest<SmsSenderRegistration>({
    path: `admin/tenants/${tenantId}/sms-sender-registrations`,
    method: "POST",
    body: request,
  });
}

export async function updateSmsSenderRegistration(
  tenantId: string,
  registrationId: string,
  request: SmsSenderRegistrationUpdateRequest,
): Promise<SmsSenderRegistration> {
  return apiRequest<SmsSenderRegistration>({
    path: `admin/tenants/${tenantId}/sms-sender-registrations/${registrationId}`,
    method: "PUT",
    body: request,
  });
}
